import React from 'react';
import { LargeTile } from './LargeTile/LargeTile';
import { MediumTile } from './MediumTile/MediumTile';
import { MicroTile } from './MicroTile/MicroTile';
import { SmallTile } from './SmallTile/SmallTile';
import { TopTenTile } from './TopTenTile/TopTenTile';
import { WinnerTile } from './WinnerTile/WinnerTile';
import { AssetTile } from './AssetTile/AssetTile';
import type { TileProps } from './tiles';

const tileMinSizes = {
  Large: 'min-h-240 lg:min-h-288 min-w-(--grid-columns-12) md:min-w-(--grid-columns-5) lg:min-w-(--grid-columns-4)',
  Medium: 'min-h-240 lg:min-h-272 min-w-(--grid-columns-6) sm:min-w-(--grid-columns-4) md:min-w-(--grid-columns-3) lg:min-w-(--grid-columns-2)',
  Numbered: 'min-h-240 lg:min-h-272 min-w-(--grid-columns-6) sm:min-w-(--grid-columns-4) md:min-w-(--grid-columns-3) lg:min-w-(--grid-columns-2)',
  Small: 'min-h-[124px]',
  Micro: 'min-h-[124px]',
  Winner: 'min-h-[124px]',
  Asset: 'h-160 md:h-208 min-w-(--grid-columns-11) md:min-w-(--grid-columns-5) lg:min-w-(--grid-columns-4)'
};

export const loadingStates = {
  Large: (props: TileProps) => <LargeTile
    className={tileMinSizes.Large}
    {...props}
    isLoading />,
  Medium: (props: TileProps) => <MediumTile
    className={tileMinSizes.Medium}
    {...props}
    isLoading />,
  Numbered: (props: TileProps) => <TopTenTile
    className={tileMinSizes.Numbered}
    {...props}
    isLoading />,
  Small: (props: TileProps) => <SmallTile
    className={tileMinSizes.Small}
    {...props}
    isLoading />,
  Micro: (props: TileProps) => <MicroTile
    className={tileMinSizes.Micro}
    {...props}
    isLoading />,
  Winner: (props: TileProps) => <WinnerTile
    className={tileMinSizes.Winner}
    {...props}
    isLoading />,
  Asset: (props: TileProps) => <AssetTile
    className={tileMinSizes.Asset}
    {...props}
    isLoading />,
};

export const loadingStatesEmpty = {
  Medium: () => <div className={tileMinSizes.Medium + ' h-240'}></div>
};